import React from 'react'
import { Route } from 'react-router-dom'
import { IndexMyTask, MyTasksEdit, MyTasksMain, MyTasksViewNew } from '../Views/Web/Tasks/MyTask/Index'
import { AllTasksMain, IndexTask, TasksCreate, TasksEdit, TasksViewNew } from '../Views/Web/Tasks/AllTask/Index'
import MainTask from '../Views/Web/Tasks/Main'

function TaskRoutes() {
    return (
      <Route path="tasks" element={<MainTask />}>

      <Route path="all-tasks" element={<AllTasksMain />}>
           <Route index element={<IndexTask/>} />
           <Route path='create' element={<TasksCreate/>} />
           <Route path='edit/:alltasksEditId' element={<TasksEdit/>} />
           <Route path='view/:alltasksViewId' element={<TasksViewNew/>} />
      </Route>

      <Route path="my-tasks" element={<MyTasksMain />}>
           <Route index element={<IndexMyTask/>} />
           {/* <Route path='create' element={<TasksCreate/>} /> */}
           <Route path='edit/:mytasksEditId' element={<MyTasksEdit/>} />
           <Route path='view/:mytasksViewId' element={<MyTasksViewNew/>} />
      </Route>
      </Route>

    )
  }
  
  export default TaskRoutes